<template>
  <div>
    <div
      v-for="(item, index) in items"
      :key="index"
      class="d-flex align-center body-2"
      :class="[classes]"
    >
      <v-avatar
        v-if="item.image"
        :size="iconSize"
        class="thick align-self-start my-auto"
      >
        <v-img :src="item.image" />
      </v-avatar>
      <v-icon
        v-else
        :size="iconSize"
        class="thick align-self-start my-auto"
        :color="item.iconColor || iconColor"
      >
        {{ item.icon || icon }}
      </v-icon>
      <span
        :class="textIndentClass"
        v-html="item.text"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'McsIconList',

  props: {
    items: {
      type: Array,
      default: () => []
    },
    iconColor: {
      type: String,
      default: 'black'
    },
    icon: {
      type: String,
      default: 'mdi-check'
    },
    iconSize: { type: Number, default: 18 },
    classes: {
      type: String,
      default: 'mb-2'
    },
    textIndentClass: {
      type: String,
      default: 'ml-3'
    }
  },

  data() {
    return {};
  },

  computed: {},

  methods: {}
};
</script>

<style></style>
